module.exports = __webpack_public_path__ + "static/media/bear.9b70581b.png";